import React, { Component } from 'react'
import './ButtonForm.css';

export default class ButtonForm extends Component {
  render() {
    const {type, button_text, onClick} = this.props
    return (
        <button type={type} onClick={onClick} className="ButtonForm">{ button_text }</button>
    )
  }
}
